import React from 'react';

const Error=({err,isBtn=false})=>{
	return (
		err?
		<p className={"error"+(isBtn?" btn-error":"")} >{err}</p>:
		null
	)
}
export default Error;